<template>
    <v-spa-mixed-modal
        :name="name"
        :use-right-panel-on-small-screens="true"
        height="auto"
        default-classes="!overflow-visible"
        @before-open="setModalAsOpened"
        @closed="reset"
        :class="currentModalPosition !== -1 ? `vm--container--position-${currentModalPosition}` : ''"
    >
        <template v-if="display.form.isVisible">
            <h2 class="mb-4 text-xl">{{ title }}</h2>
            <form-component
                :uuid="uuid"
                :on-init="onInit"
                :options="options"
                v-bind="$props"
                @submitted="hide"
                @stored="stored"
                @updated="updated"
            />
        </template>
    </v-spa-mixed-modal>
</template>

<script>
import FormComponent from "./Form.vue";
import { Display } from "@henrotaym/helpers";
import setup from "@spa/setup";

export default {
    components: {
        FormComponent
    },

    data() {
        return {
            name: "contacts.create",
            display: { form: new Display(false) },
            uuid: null,
            onInit: undefined,
            options: undefined
        }
    },

    computed: {
        currentModalPosition()
        {
            return this.$store.state.openedModals.indexOf(this.name);
        },
        isCreate() {
            return !this.uuid;
        },
        title() {
            return `${this.$t(`form.buttons.${this.isCreate ? "create" : "edit"}`)} ${this.$t('form.labels.contacts.title')}`
        }
    },

    methods: {

        setModalAsOpened()
        {
            this.$store.commit('addOpenedModal', this.name);
        },

        reset()
        {
            this.$store.commit('removeOpenedModal', this.name);
        },

        submitted()
        {
            this.hide();
        },

        /** Showing modal while initializing form. */
        show()
        {
            this.$modal.show(this.name);
            this.display.form.show();
        },

        /** Hiding modal and resetting form. */
        hide()
        {
            this.$modal.hide(this.name);
            this.display.form.hide();
        },

        stored(contact)
        {
            setup.bus.$emit('contacts.stored', { contact });
        },

        updated(contact)
        {
            setup.bus.$emit("contacts.updated", { contact });
        },

        /** @type {import('@spa/types/bus').EventBusListener<'contacts.edit', import('@spa/types/bus').PackageEventBusEvents>} */
        edit(params)
        {
            this.reset()
                .setOnInit(params.onInit)
                .setOptions(params.options)
                .setUuid(params.uuid)
                .show();
        },

        /** @type {import('@spa/types/bus').EventBusListener<'contacts.create', import('@spa/types/bus').PackageEventBusEvents>} */
        create(params)
        {
            this.reset()
                .setOnInit(params.onInit)
                .setOptions(params.options)
                .show();
        },

        setUuid(uuid)
        {
            this.uuid = uuid;

            return this;
        },

        setOnInit(onInit)
        {
            if (!onInit) return this;

            this.onInit = onInit;
            return this;
        },

        setOptions(options)
        {
            if (!options) return this;
            
            this.options = options;
            return this;
        },

        reset()
        {
            this.uuid = null;
            this.onInit = undefined;
            this.options = undefined;

            return this;
        }
    },
    
    created()
    {
        this.reset();
        setup.bus.$on('contacts.create', this.create);
        setup.bus.$on('contacts.edit', this.edit);
    },

    beforeDestroy()
    {
        setup.bus.$off('contacts.create', this.create);
        setup.bus.$off('contacts.edit', this.edit);
    }
}
</script>
